export default {
  appModel() {
    return {
      MortgageApplicationID: 0,
      InterView: this.interviewModel(),
      Applicants: [],
      MortgageRequest: this.mortgageRequestModel(),
      RequestDocument: this.requestDocumentModel()
    };
  },
  requestDocumentModel(){
    return{
      DFRequestDocID: null,
      Desc: null,
      Items:[],
    }  
  },
  interviewModel() { 
    return {
      DealPurposeDD: null,
      //RenewingDate: null,
      //RefinanceDate: null,
      ClosingDate: null,

      PropertyValue: 0,
      DownPaymentAmount: 0,
      SearchStageDD: null,
      PropertyTypeDD: null,
      OccupancyDD: null
    };
  },
  applicantModel() {
    return {
      ApplicantID: 0,
      Identification: this.IdentificationModel()
    };
  },
  IdentificationModel() {
    return {
      SalutationDD: -1,
      FirstName: null,
      LastName: null,
      PrimaryFlag: false,
      DOB: null,
      Email: null,
      Mobile: null,
      HomePhone: null,
      SIN: null,
      MartialStatusD: -1,
      ApplicantGroupTypeDD: -1,
      RelationshipDD: -1,
      FirstTimeHomeBuyerFlag: null,
      IdentificationLst:[]
    };
  },
  IdentificationItemModel() {
    return {
      IdentificationID: null,
     Type: -1,
     Country: null,
     IdentificationNumber: null
    };
  },
  addressModel() {
    return {
      MonthsAtAddress: null,
      AddressID: 0,
      ShortFormatAddress: null,
      FullFormatAddress: null,
      UnitNumber: null,
      StreetNumber: null,
      StreetName: null,
      StreetTypeDD: null,
      StreetDirectionDD: null,
      City: null,
      ProvinceDD: null,
      InternationalPostalCode: null,
      PostalFsa: null,
      PostalLdu: null,
      CountryTypeDD: 1,
      AddressLine1: null,
      AddressLine2: null,
      ApplicantAddressID: 0
    };
  },
  getApplicantAddressModel() {
    let rv = {
      AddressID: 0,
      MonthsAtAddress: 0,
      ApplicantAddressTypeDD: null,
      ResidentialStatusDD: null,
      Rent: 0,
      Address: this.addressModel()
    };
    return rv;
  },
  applicantAddressModel() {
    let rv = {
      ApplicantAddressID: 0,
      ApplicantAddress: {
        ApplicantAddress: this.addressModel()
      }
    };
    rv.ApplicantAddress.ApplicantAddress.ApplicantAddressTypeDD = 1;
    rv.ApplicantAddress.ApplicantAddress.MonthsAtAddress = null;
    rv.ApplicantAddress.ApplicantAddress.ResidentialStatusDD = null;
    rv.ApplicantAddress.ApplicantAddress.Rent = null;

    return rv;
  },
  incomeModel() {
    return {
      IncomeID: null,
      IncomeTypeDD: null,
      IncomeAmount: 0,
      IncomePeriodDD: null,
      JobTitle: null,
      OccupationDD: null,
      OperatingAsDD: null,
      IndustrySectorDD: null,
      EmploymentHistoryStatusDD: null,
      EmploymentHistoryTypeDD: null,
      TimeAtJob: null,
      EmployerName: null,
      EmployerPhoneNumber: null,
      Address: this.addressModel(),

      Desc: null
    };
  },
  propertyModel() {
    return {
      PropertyID: null,
      Address: this.addressModel(),
      OccupancyTypeDD:null,
      PropertyTypeDD:null,
      PropertyValue:null,
      AnnualTaxes:null,
      RentalIncome:null,
 
      Mortgages: [],
      strPurchaseDate: null,
      EstimatedPropertyValue:0,      
      CondoFees:0,
      OriginalValue:null 
    };
  },
  mortgageModel() {
    return {   
      TypeofMortgage: 1,   
      MortgageID: null,
      PaymentFrequencyDD:null,
      Balance:null,
      RateTypeDD:null,
      InterestRate:null,
      LoanTypeDD:null,
      MortgageTypeDD: null
    };
  },
  assetModel(){
    return{
      AssetID: 0,
      AssetTypeDD:null
    }
  },
  LiabilityModel(){
    return{
      LiabilityID: 0,
      LiabilityType:null,
      Description: "",
      Limit: null,
      Balance: null
    }
  },
  mortgageRequestModel(){
    return {
      RequestedMortgageAmount:null,
      SubjectProperty: {
        Address: this.addressModel(),
        ClosingDate: null,
        PropertyTypeDD:null,
        DwellingStyleDD:null,
        NewConstructionDD:null,
        Age:null,
        CondoFees:null,
        Mortgages:[]
      }
    }
  }
};
